import NextImage, { ImageLoaderProps } from 'next/image';
import get from 'ts-get';

import { CardButton } from '../../../../../../components/Cards/CardButton';
import { getCatchCardEventProperties } from '../../../../../../components/PostsViewer/helpers/getCatchCardEventProperties';
import { useAnalytics } from '../../../../../../contexts/AnalyticsContext/AnalyticsContext';
import { GetFishingWaterSummary_fishingWater_catches_edges_node_post } from '../../../../../../interfaces/graphql';
import { EmptyCatchCardImage } from '../../EmptyCatchCardImage/EmptyCatchCardImage';
import { getImgProxyLoader } from '../../../../../../helpers/imageLoaders/imgProxy';

export const FishingWaterViewCatchesList = ({
  catchPosts,
  openPostViewer,
}: {
  catchPosts: GetFishingWaterSummary_fishingWater_catches_edges_node_post[];
  openPostViewer: (postId?: string) => Promise<void>;
}) => {
  const { currentPage } = useAnalytics();

  return (
    <div className="bg-lake-fog mt-8 grid grid-cols-2 gap-2 sm:grid-cols-1">
      {catchPosts.map(post => {
        const image = get(post, p => p.images.edges[0].node);
        const imageUrl = image?.url;
        const imageWidth = image?.width || 0;
        const imageHeight = image?.height;

        const imgProxyLoader = ({ src, width, quality }: ImageLoaderProps): string =>
          getImgProxyLoader(src, width, imageWidth, imageHeight, { quality });

        return (
          <CardButton
            className="relative aspect-2/3 cursor-pointer rounded-md p-0! sm:aspect-video"
            data-testid={`recent-catch-${post._id}`}
            id={post._id}
            key={post._id}
            eventProperties={getCatchCardEventProperties({
              postId: post._id,
              currentPage,
              source: 'explore-fishingwater-drawer',
            })}
            onClick={() => void openPostViewer(post._id)}
            ariaLabel="catch in this fishing water"
          >
            {imageUrl ? (
              <NextImage
                alt="recently logged catches"
                className="size-full rounded-md object-cover"
                src={imageUrl}
                loader={imgProxyLoader}
                fill
                sizes="350px"
              />
            ) : (
              <EmptyCatchCardImage />
            )}
          </CardButton>
        );
      })}
    </div>
  );
};
